'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-popover/dist/index.cjs');
var React = require('react');
var Content_web_styles = require('./Content.web.styles.cjs');

/**
 *
 */ const Content = ({ side, align, hideArrow = false, customPopoverWidth, children })=>{
    // const [hasScrollBar, setHasScrollBar] = useState(false);
    const ref = React.useRef(null);
    // const { isAtBottom, handleScroll } = useScrollBottomSpy(ref);
    // const onMouseEnterHandler = () => {
    //   setIsContentHovered(true);
    // };
    // const onMouseLeaveHandler = () => {
    //   setIsContentHovered(false);
    // };
    // const handleOnOpenFocus = () => {
    //   const scrollbarShown = ref.current?.scrollHeight > ref.current?.clientHeight;
    //   setHasScrollBar(scrollbarShown);
    // };
    const renderArrow = ()=>{
        if (!hideArrow) {
            return /*#__PURE__*/ jsxRuntime.jsx(index.Arrow, {
                css: Content_web_styles.arrow,
                width: 18,
                height: 9
            });
        }
    };
    /*
   * This is an invisible psuedo element that is used to
   * help transition the user's cursor from the trigger to the content
   */ // const renderTransitionTriangle = () => (
    //   <div css={styles.transitionTriangle} className="PopoverTransitionTriangle" aria-hidden="true" />
    // );
    const contentStyles = [
        Content_web_styles.content,
        customPopoverWidth && Content_web_styles.customWidth(customPopoverWidth)
    ];
    return /*#__PURE__*/ jsxRuntime.jsx(index.Portal, {
        children: /*#__PURE__*/ jsxRuntime.jsx(index.Content, {
            side: side,
            align: align,
            // onMouseEnter={onMouseEnterHandler}
            // onMouseLeave={onMouseLeaveHandler}
            className: "PopoverContent",
            css: Content_web_styles.radixWrapper,
            children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: contentStyles,
                ref: ref,
                children: [
                    renderArrow(),
                    children
                ]
            })
        })
    });
};
Content.displayName = "Popover.Content";

exports.Content = Content;
//# sourceMappingURL=Content.web.cjs.map
